import styled, {keyframes} from 'styled-components';
import {Loader2} from 'lucide-react';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Button} from '@guestapp/old-ui-kit';
import ModalSheet from 'components/common/ModalSheet';
import {StatusModal} from '@chekin/shared';
import {CardStackContainer} from 'components/upselling/EnhanceYourStay/styled';

export const StyledModalGuestRegistered = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 392px;
  margin: 0 auto;
  width: 100%;

  @media (min-width: ${DEVICE.laptop}) {
    max-width: 540px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;

  img {
    width: 54px;
    height: 54px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  .registered-guest-modal__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 30px;
    font-weight: 400;
    color: #23262f;
    padding: 20px;
  }

  @media (max-width: ${DEVICE.mobileL}) {
    & .registered-guest-modal__title {
      gap: 0;
    }
  }
`;

export const ModalTitleText = styled.div`
  margin: 0;
  white-space: nowrap;
  font-family: ${props => props.theme.fonts.fontFamily.titles.font_name};
  color: ${props => props.theme.colors.branding.fontPrimary};
  font-size: 18px;
  font-weight: bold;

  @media (max-width: ${DEVICE.mobileL}) {
    white-space: normal;
  }
`;

export const ModalSubtitle = styled.div`
  font-family: ${props => props.theme.fonts.fontFamily.body.font_name};
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontPrimary
      : props.theme.colors.$p10};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 275px;
  margin-top: 19px;

  b {
    color: ${props =>
      props.theme.hasTemplate
        ? props.theme.colors.$p10
        : props.theme.colors.branding.fontPrimary};
  }
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  margin-bottom: 64px;
`;
export const CloseButton = styled(Button)`
  margin: 24px auto 0;
`;

export const NextStepRegisterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
export const NextStepTitle = styled.b`
  margin-bottom: 24px;
  max-width: 270px;
  text-align: center;
  margin-top: 28px;
  color: ${props => props.theme.colors.branding.fontPrimary};
  @media (min-width: ${DEVICE.mobileL}) {
    margin-top: 0;
  }
`;

export const IncompleteGuestText = styled.div`
  margin-bottom: 48px;
  color: ${props => props.theme.colors.branding.fontPrimary};
`;

export const CompletedGuestText = styled.div`
  margin-bottom: 24px;
  color: ${props => props.theme.colors.branding.fontPrimary};
`;

export const BookingPAymentRequiredText = styled.div`
  max-width: 327px;
  text-align: center;
  margin-bottom: 48px;
  color: ${props => props.theme.colors.branding.fontPrimary};
`;

export const StyledButton = styled(Button)`
  margin-bottom: 36px;
  width: 100%;
  max-width: 327px;
  box-shadow: none;
  border: none;
  &:last-child {
    margin-bottom: 36px;
    @media (min-width: ${DEVICE.laptop}) {
      margin-bottom: 48px;
    }
  }
`;

export const StyledStatusModal = styled(StatusModal)`
  @media (min-width: ${DEVICE.tablet}) {
    left: 0;
  }
`;

export const StyledModalSheet = styled(ModalSheet)<{$hasInfoBox?: boolean}>`
  &-content {
    @media (min-width: ${DEVICE.mobileL}) {
      padding: 48px 20px 48px;
      max-width: 375px;
      ${props => (props.$hasInfoBox ? `max-width: 541px;` : '')}
    }
  }
  @media (min-width: ${DEVICE.laptop}) {
    left: 0;
  }
`;

export const SignUpSuggestionModalContent = styled.div`
  margin-bottom: 48px;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const DealsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 12px 16px;
  animation: ${fadeIn} 0.3s ease-out;

  @media (min-width: ${DEVICE.laptop}) {
    padding: 0 24px 24px;
    width: 520px;
    height: 700px;
  }
`;

export const DealsStatusBanner = styled.div<{$isComplete: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 14px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  max-width: 300px;
  flex-shrink: 0;
  background: ${({$isComplete, theme}) =>
    $isComplete ? 'rgba(34, 197, 94, 0.1)' : theme.colors.branding.boxesModals};
  color: ${({$isComplete, theme}) =>
    $isComplete ? '#22c55e' : theme.colors.branding.fontSecondary};
  animation: ${slideUp} 0.3s ease-out;

  @media (min-width: ${DEVICE.laptop}) {
    font-size: 13px;
    padding: 8px 16px;
    margin-bottom: 12px;
    max-width: 440px;
  }
`;

export const SpinningLoader = styled(Loader2)`
  animation: ${spin} 1s linear infinite;
`;

export const DealsHeader = styled.div`
  text-align: center;
  margin-bottom: 6px;
  width: 100%;
  max-width: 300px;
  flex-shrink: 0;
  animation: ${slideUp} 0.4s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: backwards;

  @media (min-width: ${DEVICE.laptop}) {
    max-width: 440px;
    margin-bottom: 12px;
  }
`;

export const DealsTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  margin: 0 0 2px 0;

  @media (min-width: ${DEVICE.laptop}) {
    font-size: 22px;
  }
`;

export const DealsSubtitle = styled.p`
  font-size: 13px;
  color: ${({theme}) => theme.colors.branding.fontSecondary};
  margin: 0;
  line-height: 1.4;

  @media (min-width: ${DEVICE.laptop}) {
    font-size: 15px;
  }
`;

export const StackWrapper = styled.div`
  animation: ${slideUp} 0.5s ease-out;
  animation-delay: 0.2s;
  animation-fill-mode: backwards;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-height: 0;
`;

export const CompactCardStack = styled(CardStackContainer)`
  height: 380px;
  max-width: 280px;

  @media (min-width: 375px) {
    max-width: 300px;
    height: 400px;
  }

  @media (min-width: ${DEVICE.laptop}) {
    max-width: 430px;
    height: 560px;
  }
`;

export const SkipAllButton = styled(Button)`
  margin-top: 8px;
  padding: 6px 14px;
  color: ${({theme}) => theme.colors.branding.fontSecondary};
  font-size: 12px;
  animation: ${fadeIn} 0.4s ease-out;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    color: ${({theme}) => theme.colors.branding.fontPrimary};
  }

  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 12px;
    font-size: 13px;
    padding: 8px 16px;
  }
`;

export const DealsEmptyStateContainer = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: ${({theme}) => theme.colors.branding.fontSecondary};
  font-size: 14px;

  @media (min-width: ${DEVICE.laptop}) {
    padding: 60px 40px;
    font-size: 15px;
  }
`;
